import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ad stats
 */
export class AdStatsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Number} deps.favorites
   * @param {Number} deps.views
   */
}
